module.exports = __webpack_public_path__ + "static/bigminerLogo-e33c83cd56ede9bdf05d923c799d5ac2.svg";